<div class="patient">
  <div class="wrapper">
    

    <!-- ========================== header (start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel">
        <div style="display: flex; align-items: center">
          <h1 class="t-title-main">
           Lab Results
          </h1>
          <div class="l-flex l-flex-c t-field t-field-pad" style="margin-left: 2em">
            <label style="font-size: 14pt;" *ngIf="loginService.userType == 'doctor'"> Status </label>

            <i class="t-sep" *ngIf="loginService.userType == 'doctor'"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="status"
              (change)="getLabResults()"
              style="font-size: 14pt;"
            >
              <option value="Old_reports" *ngIf="loginService.userType == 'secretary' || loginService.userType == 'admin'">Old Lab Inventories</option>
              <option value="Messenger_reports" *ngIf="loginService.userType == 'nurse' || loginService.userType == 'secretary' || loginService.userType == 'admin'">{{loginService.userType == 'secretary'? 'Unsigned ' : ''}}Lab Inventory Reports</option>
              <option value="Needs_payer">Payer Missing</option>
              <option value="Awaiting_transfer" matTooltip="New samples that need to be sent to Lab" *ngIf="loginService.userType == 'nurse' || loginService.userType == 'secretary' || loginService.userType == 'admin'">Awaiting pickup</option>
              <option value="Awaiting_Lab_Results" *ngIf="loginService.userType != 'nurse'" matTooltip="Sent to Lab">Awaiting results</option>
              <option value="Needs_Analysis" *ngIf="loginService.userType != 'nurse'">Awaiting Doctor's Review</option>
              <option value="Needs_Assignment" *ngIf="loginService.userType != 'nurse'">Awaiting Assignment</option>
            </select>
          </div>

          <div class="l-flex l-flex-c t-field t-field-pad" style="margin-left: 2em" *ngIf="status == 'Awaiting_transfer' || status == 'Awaiting_Lab_Results'">
            <label> Laboratory </label>

            <i class="t-sep"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="lab"
              (change)="getLabResults()"
            >
              <option value="">-- Select Lab --</option>
              <option value="" *ngIf="status == 'Awaiting_Lab_Results'">All</option>
              <option value="patholab">פתולאב​</option>
              <option value="medica">מדיקה​</option>
              <option value="LEM">LEM</option>
              <option value="megalab">מגהלאב​</option>
            </select>
          </div>

          <nav class="header-menu">
            <span *ngIf="loginService.userType === 'nurse' && status == 'Awaiting_transfer' && lab && labResults && labResults.length > 0 && reportSelected()" 
              class="header-menu-link icon-file"
              matTooltip="Sign sample list for messenger" (click)="makeMessengerReport()">
            </span>
          </nav>
          
        </div>
        
        <span
          *ngIf="status == 'Old_reports'"
          style="margin-left: 1em; display: flex;"
        >
          From
          <input
            [matDatepicker]="startDatepicker"
            [(ngModel)]="startdate"
            [max]="enddate"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (click)="startDatepicker.open()"
            (dateChange)="getInventoryHistory()"
          />
          <mat-datepicker #startDatepicker></mat-datepicker>
          Until
          <input
            [matDatepicker]="endDatepicker"
            [(ngModel)]="enddate"
            [min]="startdate"
            (click)="endDatepicker.open()"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (dateChange)="getInventoryHistory()"
          />
          <mat-datepicker #endDatepicker></mat-datepicker>
        </span>
        <div
          style="
            width: 70%;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
          "
        >
          
        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
        <div
          *ngIf="
            (loginService.isAdmin || loginService.userType == 'secretary' || loginService.userType == 'nurse') &&
            (loginService.separatedClinic || loginService.SeparateZimun)
          "
          style="position: absolute; right: 6em"
        >
          <div class="l-flex l-flex-c t-field t-field-pad" *ngIf="loginService.userType != 'doctor' && status != 'Messenger_reports'">
            <label matTooltip="שם הרופא">
              <img src="../../assets/icons/drb.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <select
                [(ngModel)]="doctor"
                class="t-select w100"
                style="text-align: center"
                (change)="getLabResults()"
              >
                <option [value]="null">All</option>
                <!-- <option *ngIf="awlExam && ! examTypes.includes(awlExam)" [value]="awlExam">{{awlExam}}</option> -->
                <ng-container *ngFor="let e of loginService.clinicUsers">
                  <option [value]="e.UID">{{ e.Name }}</option>
                </ng-container>
              </select>
            </span>
          </div>
        </div>

        <!-- *ngIf="examList && examList.length && loginService.userType==='admin'" -->
        <img
          style="cursor: pointer; position: absolute; right: 3%; top: 50%; transform: translateY(-50%)"
          matTooltip="Download CSV"
          *ngIf="false &&loginService.userType === 'admin'"
         
          height="31em"
          src="../../assets/icons/file.svg"
        />
       
        </div>
    </div>
    </header>

     <main class="l-deashboard" *ngIf="status != 'Messenger_reports' && status != 'Old_reports'">
      
        <div class="l-flex patient-item" *ngFor="let result of labResults">
        <button [matTooltip]="getPathNotes(result)" class="w100 patient-item-link">
          
            <div class="l-table h100" (click)="showReport(result)">
            <span class="l-td-m patient-item-cell patient-id" *ngIf="loginService.userType === 'nurse' && status == 'Awaiting_transfer' && lab && doctor == null">
               Add to report <input type="checkbox" [(ngModel)]="result.selected" />
            </span>
            <span class="l-td-m patient-item-cell patient-id">
             <strong>ID: {{ result.ID }}</strong>
            </span>

            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="result.Last">
              {{ result.First + ' ' + result.Last }}
            </span>
            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="! result.First && !result.Last && !result.PID">
              Patient NOT found!
            </span>
            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="result.ExamType && result.CreationTime">
              {{ result.ExamType }} {{result.CreationTime | date:'dd/MM/yyyy'}}
            </span>
            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="result.Count">
                Num. of samples: {{result.pathology.length}} of {{result.Count}} 
            </span>
            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="result.ReceptionDate">
              Recv. {{result.Lab}} on {{result.ReceptionDate | date:'dd/MM/yyyy'}}  
            </span>
            <span class="l-td-m patient-item-cell patient-name-first" [ngClass]="result.exception ? 'problem':''" *ngIf="result.ReceptionDate">
                Results: {{result.exception? 'Abnormal': 'Normal'}}
            </span>
            <span
              class="l-td-m patient-item-cell patient-name-first"
              *ngIf="(loginService.isAdmin || loginService.userType == 'secretary') && result.UID">
              Dr: {{ loginService.getDocByUID(result.UID) }}
            </span>
            </div>  
          
          </button>
        <a *ngIf="result.ExamID"
          class="l-td-m patient-item-exit"
          matTooltip="Open Exam"
          (click)="goExam(result.ExamID,result.PID)"
        ></a>
        <a *ngIf="status == 'Needs_Assignment' && result.PID" class="l-td-m patient-item-exit"
          matTooltip="Open Patient" (click)="goPatient(result.PID)"
          ></a>
      </div>
     </main>

     <main *ngIf="status == 'Messenger_reports' || status == 'Old_reports'" class="reports">
      
        <div class="l-flex patient-item" *ngFor="let inventory of (status == 'Messenger_reports'? activeInventories : completedInventories)">
        
          <button class="w100 patient-item-link">
            <div class="l-table h100" (click)="inventory.LabMessenger? openOldInventory(inventory) :openInventory(inventory)">
            <span class="l-td-m patient-item-cell patient-id">
             <strong>Inventory ID: {{ inventory.AutoIndex }}</strong>
            </span>

            <span class="l-td-m patient-item-cell patient-name-first">
              Lab: {{ inventory.Lab }}
            </span>
            <span class="l-td-m patient-item-cell patient-name-first">
              Pickup Date: {{inventory.PickupDate | date:'dd/MM/yyyy'}}
            </span>
            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="! inventory.SigningNurse || ! inventory.SigningSecretary || ! inventory.LabMessenger">
              {{ getNeededSignatures(inventory) }}
            </span>
            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="inventory.LabMessenger">
              Completed by Messenger: {{ inventory.LabMessenger }} on {{ inventory.MessengerDate | date:'dd/MM/yyyy' }}
            </span>
            </div>  
          </button>
       
      </div>
     </main>
 
    <aside class="l-sidebar l-flex l-column">
      <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

      <!-- user panel (start) -->
      <div class="userPanel">
        <div class="search-patient">       
            <div class="t-field l-flex t-twin-fieldset"> 
            <div class="w100">
              <button class="search-btn"
                matTooltip="Patients"
                routerLink="/patsearch"
              >
                Go Back to Patients
              </button>

            </div>
          </div>
        
        </div>

        
      </div>
      <!-- user panel (end) -->

      <!-- main nav (start) -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- main nav (end) -->
      <app-docpanel></app-docpanel>
    </aside>

    <!-- ========================== main sidebar (end) ========================== -->

    <app-bottombar></app-bottombar>
</div>

<!-- Inventory Search Popup -->

</div>
<app-messenger-report [lab]="lab" *ngIf="messengerReportID" [reportID]="messengerReportID" (closed)="closeWPDF($event)" [signed]="inventorySigned"></app-messenger-report>
<app-labreport *ngIf="reportView()" [reportid]="reportToShow" (closed)="closeWPDF(null)" [pdf]="pdf" [inventoryId]="pdfMessengerID"></app-labreport>

